import { useState } from 'react';

import { Popover } from '@any-ui-react/core';
import classnames from 'classnames';

import { EmojiIcon } from '@anyx/shared-icons';


import { EmojiPicker } from '../../emoji-picker';

export interface EmojiPopoverProps {
  onSelect?: React.ComponentProps<typeof EmojiPicker>['onSelect'];
  disabled?: boolean;
}

export function EmojiPopover({ onSelect, disabled }: EmojiPopoverProps) {
  const [isOpen, setIsOpen] = useState(false);

  const closePopover = () => {
    setIsOpen(false);
  };
  return (
    <Popover
      closeOnClickOutside
      onClose={closePopover}
      opened={isOpen}
      position="right-start"
      disabled={disabled}
      withinPortal
      offset={5}
    >
      <Popover.Target>
        <div className="w-fit">
          <button
            className={classnames(
              'border-gray-2 hover:border-gray-5 grid h-8 w-8 place-items-center rounded-sm border',
              { 'bg-gray-0': isOpen }
            )}
            type="button"
            onClick={() => setIsOpen(!isOpen)}
          >
            <EmojiIcon className="h-6 w-6" />
          </button>
        </div>
      </Popover.Target>

      {!disabled && (
        <Popover.Dropdown className="rounded-[0.7rem] border-0 p-0 drop-shadow-none">
          <EmojiPicker
            onSelect={(emoji) => {
              onSelect?.(emoji);
              closePopover();
            }}
          />
        </Popover.Dropdown>
      )}
    </Popover>
  );
}
